<template>
    <p class="body text-valence-grey-750">This action will:</p>
    <ul class="list-disc pl-5 body text-valence-grey-750 space-y-1">
        <li v-for="consequence in DELETION_CONSEQUENCES" :key="consequence">{{ consequence }}</li>
    </ul>
    <p class="body-bold text-red-600">This cannot be undone.</p>
</template>

<script setup lang="ts">
const DELETION_CONSEQUENCES = [
    "Deactivate your account immediately",
    "Prevent you from logging in",
    "Your data will be fully deleted within 30 days of the request, unless your organization has a data retention policy in place that requires retaining it longer. In that case, your data will be deleted as soon as the policy allows.",
];
</script>
